import { useState, useRef, useEffect, useCallback } from 'react'

const DROPDOWN_MAX_HEIGHT = 300
const DROPDOWN_MARGIN = 8

/**
 * Calculates if dropdown should appear above the input
 */
const shouldShowAbove = (containerRect: DOMRect): boolean => {
    const spaceBelow = window.innerHeight - containerRect.bottom
    const spaceAbove = containerRect.top
    const requiredSpace = DROPDOWN_MAX_HEIGHT + DROPDOWN_MARGIN
    return spaceBelow < requiredSpace && spaceAbove > spaceBelow
}

/**
 * Hook to determine dropdown position based on available space
 */
export const useDropdownPosition = (isOpen: boolean) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [showAbove, setShowAbove] = useState(false)

    const updatePosition = useCallback(() => {
        if (!containerRef.current || !isOpen) return
        const rect = containerRef.current.getBoundingClientRect()
        setShowAbove(shouldShowAbove(rect))
    }, [isOpen])

    useEffect(() => {
        updatePosition()
        window.addEventListener('scroll', updatePosition, true)
        window.addEventListener('resize', updatePosition)
        return () => {
            window.removeEventListener('scroll', updatePosition, true)
            window.removeEventListener('resize', updatePosition)
        }
    }, [updatePosition])

    return { containerRef, showAbove }
}

